// extracted by mini-css-extract-plugin
export default {"prices":"price_prices__otIPt","priceText":"price_priceText__p4r7Y","priceBeforeDiscountText":"price_priceBeforeDiscountText__lJrAb","withMargin":"price_withMargin__d1IIR"};